import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/insurance-payment-type-rate";

export const pagingIPTR = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getIPTRById = (IPTRId) => axios.get(API_PATH + "/getbyid/" + IPTRId);

export const saveOrUpdateIPTR = IPTR => axios.post(API_PATH + "/save", IPTR);

export const deleteIPTR = IPTRId => axios.delete(API_PATH + '/mark-delete/' + IPTRId);
